import { Alert } from "@marekl/adminer/components";

/**
 * Renders sanity-check warnings about a rule set.
 *
 * Deliberately an Alert and not a blocked save: every case it reports is
 * something the backend accepts, and some of them are correct on
 * purpose. The wording says "check this", not "fix this".
 */
export function RuleChecks({ warnings }: { warnings: string[] }) {
  if (warnings.length === 0) return null;
  return (
    <Alert variant="warn" title="Zkontrolujte nastavení">
      <ul>
        {warnings.map((w) => (
          <li key={w}>{w}</li>
        ))}
      </ul>
    </Alert>
  );
}
